import typeCheck from 'common/util/typeCheck';

import { SR_API_ACTION_ACCOUNT_MANAGER_GET_BY_LISTING_ID } from 'api/actionTypes';

export default async function getByListingId({ state, apiClient }, { listingId }) {
  typeCheck('listingId::Number', listingId);

  const accountManagerStatePath = ['accountManagers', 'byListingId', listingId];
  if (state.get(accountManagerStatePath)) {
    return state.get(accountManagerStatePath);
  }

  return apiClient.postWithState({
    action: SR_API_ACTION_ACCOUNT_MANAGER_GET_BY_LISTING_ID,
    state: state,
    payload: {
      listingId: listingId,
    },
    onSuccess(accountManager) {
      state.set(accountManagerStatePath, accountManager);
      return accountManager;
    },
  });
}
